import { IconError404 } from "@tabler/icons-react";
import { Wrapper } from "../components/layout/wrapper";
import "./not-found.scss"

const NotFoundPage = () => {

  return (
    <Wrapper.Centered className="error">
      <meta name="robots" content="noindex" />
      <IconError404 className="picto" />
    </Wrapper.Centered>);

}

export default NotFoundPage;
